import { Encoder, decode } from '@msgpack/msgpack';
/**
 * Reused MessagePack encoder configured to pack regular JS numbers as
 * IEEE-754 float32 instead of the default float64. Every game-state
 * snapshot carries ~15 numeric fields × N entities; halving the per-
 * number wire cost from 9 bytes (float64 + marker) to 5 bytes
 * (float32 + marker) is a ~40% reduction on the dominant wire payload.
 *
 * The encoder is deliberately a single shared instance — its internal
 * scratch buffer reuses across calls, eliminating the per-encode
 * allocation that `encode()` from the top-level API performs. With
 * tens of thousands of EntityUpdate frames per second across a busy
 * server this is significant.
 *
 * Float32 keeps ~7 decimal digits of precision, which is plenty for
 * the world-space coordinates we ship (sectors are 1000-unit grids
 * and entities live within ±SECTOR_SIZE of an integer multiple). HP /
 * shield / energy / counters are integers anyway and round-trip
 * cleanly.
 */
const sharedEncoder = new Encoder({
    forceFloat32: true,
    // Coalesces `key: undefined` to "key absent" so the broadcast loop's
    // sparse fields (vx/vy/vz/rw/sh/en/men/bl/extra) don't ride the wire
    // when they're meant to be omitted.
    ignoreUndefined: true,
});
export function encodeMessage(msg) {
    // `encode()` returns a fresh copy each call (vs `encodeSharedRef`
    // which aliases the encoder's reusable scratch buffer). uWS may
    // hold onto the buffer until backpressure drains, so the copy is
    // mandatory; the encoder still beats the top-level `encode()` from
    // the library because the internal buffer reuses across calls.
    return sharedEncoder.encode(msg);
}
export function decodeMessage(data) {
    const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
    return decode(bytes);
}
//# sourceMappingURL=codec.js.map